interface Configuration {
  baseURL: string;
}

const Config: Configuration = {
  baseURL: "https://figuraata-wh.herokuapp.com",
  //baseURL: "http://localhost:1337",
};

export default Config;
